// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "f1eb1e57",
    "hash": "f1eb1e57",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "f1eb1e57",
    "semverString": null,
    "version": "5.0.0"
};
/* tslint:enable */
